import React from 'react'
import { Button } from '@deal/components'
import ExpertRating from '#src/components/Reviews/ExpertRatingModal'
import classNames from 'classnames'
import Star from './star.svg'
import styles from './styles.css'

interface ReviewProps {
  expertId: string
  largeIcons?: boolean
  invertedIcons?: boolean
  onCloseRatingModal?: () => void
}

interface ReviewState {
  hoveredStars: number
  expertRatingModalOpen: boolean
  selectedStars?: number
}

class Review extends React.Component<ReviewProps, ReviewState> {
  state = { hoveredStars: 0, expertRatingModalOpen: false, selectedStars: 0 }

  public handleHoverStar = (index: number) => () => this.setState({ hoveredStars: index })

  public handleExitHoverStar = () => this.setState({ hoveredStars: 0 })

  public handleClickStars = (index: number) => () =>
    this.setState({ selectedStars: index, expertRatingModalOpen: true, hoveredStars: 0 })

  public handleCloseExpertRatingModal = () => {
    this.setState({ expertRatingModalOpen: false, selectedStars: 0 })

    if (this.props.onCloseRatingModal) {
      this.props.onCloseRatingModal()
    }
  }

  public render() {
    const { hoveredStars, expertRatingModalOpen, selectedStars } = this.state
    const { expertId, largeIcons, invertedIcons } = this.props

    const iconClass = classNames({
      [styles.largeIcon]: largeIcons,
      [styles.smallIcon]: !largeIcons,
      [styles.regularIcon]: !invertedIcons,
      [styles.invertedIcon]: invertedIcons
    })

    return (
      <div className={styles.container}>
        {[1, 2, 3, 4, 5].map(index => (
          <Button
            key={index}
            variant="link"
            className={iconClass}
            onMouseEnter={this.handleHoverStar(index)}
            onMouseLeave={this.handleExitHoverStar}
            onClick={this.handleClickStars(index)}
          >
            <Star key={index} className={index <= hoveredStars ? styles.starFilled : ''} />
          </Button>
        ))}
        {expertRatingModalOpen && (
          <ExpertRating
            isOpen
            onCloseModal={this.handleCloseExpertRatingModal}
            expertProfileId={expertId}
            expertStarRating={selectedStars}
          />
        )}
      </div>
    )
  }
}

export default Review
